import { render, staticRenderFns } from "./PurchaseOrderItem.vue?vue&type=template&id=745d3a06&scoped=true"
import script from "./PurchaseOrderItem.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderItem.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderItem.vue?vue&type=style&index=0&id=745d3a06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745d3a06",
  null
  
)

export default component.exports